import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { AppNotification } from "../models/notificationModels";
import { useAppDispatch } from "../../hooks/sharedHooks";
import { markAsRead, closePanel } from "../notificationsSlice";
import colors from "../../themes/colors";
import moment from "moment";
import { dt } from "../../themes/redesignTokens";

const eventTypeColorMap: Record<number, string> = {
  1: dt.blue,
  2: colors.secondary.gray40,
  3: colors.primary.green,
  4: colors.primary.red,
  5: colors.icons.orange,
  6: colors.icons.orange,
  7: colors.icons.orange,    // ProviderConfirmationRequested
  8: colors.primary.green,   // ProviderConfirmedService
  9: "#FF733E",              // ConfirmationReminder (amber/orange)
  10: colors.primary.red,    // ConfirmationOverdue
  11: colors.primary.red,    // PastDeadlineWarning
};

interface NotificationItemProps {
  notification: AppNotification;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notification }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    if (!notification.isRead) {
      dispatch(markAsRead(notification.id));
    }
    dispatch(closePanel());
    if (notification.linkUrl) {
      navigate(notification.linkUrl);
    }
  };

  const borderColor = eventTypeColorMap[notification.eventType] || colors.secondary.gray40;

  return (
    <Box
      onClick={handleClick}
      sx={{
        padding: "12px 16px",
        cursor: "pointer",
        backgroundColor: notification.isRead ? "transparent" : "#f0f7ff",
        borderBottom: "1px solid #e5e7eb",
        borderLeft: `4px solid ${borderColor}`,
        "&:hover": {
          backgroundColor: notification.isRead ? "#f9fafb" : "#e8f2ff",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "4px",
        }}
      >
        <p
          className="text-14-medium"
          style={{
            color: "#333",
            fontWeight: notification.isRead ? 400 : 600,
          }}
        >
          {notification.title}
        </p>
        {!notification.isRead && (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#2563eb",
              flexShrink: 0,
              marginTop: "6px",
              marginLeft: "8px",
            }}
          />
        )}
      </Box>
      <p className="text-12-regular" style={{ color: "#6b7280" }}>
        {notification.message}
      </p>
      <p
        className="text-12-regular"
        style={{ color: "#9ca3af", marginTop: "4px" }}
      >
        {moment(notification.createdDate).fromNow()}
      </p>
    </Box>
  );
};

export default NotificationItem;
